import { CONSTANTS } from '@sohohouse/platform-resources'
import Vue from 'vue'

import accountStore from '~/store/user/account'
import accountVerificationEmailsStore from '~/store/user/account-verification-emails'
import communicationPreferencesStore from '~/store/user/communication-preferences'
import membershipStore from '~/store/user/membership'
import profileStore from '~/store/user/profile'
import identityStore from '~/store/user/identity'
import interestsStore from '~/store/user/interests'
import occupationStore from '~/store/user/occupations'

export default {
  state: () => ({ meta: { isOnboarding: false } }),
  actions: {
    fetchUser ({ dispatch }) {
      return Promise.all([
        dispatch('account/fetchAccount'),
        dispatch('membership/fetchMembership'),
        dispatch('profile/fetchProfile')
      ])
    },
    updateUserOnboarding ({ commit }, value) {
      commit('updateOnboarding', value)
    }
  },
  getters: {
    accessToken: (_, __, rootState) => rootState.oauth.accessToken,
    user: (_, getters) => ({
      accessToken: getters.accessToken,
      account: getters['account/account'] || {},
      membership: getters['membership/membership'] || {},
      profile: getters['profile/profile'] || {}
    }),
    membershipType: (_, getters) => getters['membership/membership'] && getters['membership/membership'].membershipType || '',
    userFailed: (_, getters) =>
      getters['account/failed'] || getters['membership/failed'] || getters['profile/failed'],
    userFetching: (_, getters) =>
      getters['account/fetching'] || getters['membership/fetching'] || getters['profile/fetching'],
    isEveryHouseMember: s =>
      s.membership.data.subscriptionType === CONSTANTS.SUBSCRIPTION_TYPES.EVERY ||
      s.membership.data.subscriptionType === CONSTANTS.SUBSCRIPTION_TYPES.EVERY_PLUS,
    isActiveMember: s => s.membership.data.isActive,
    isActivePlusMember: s => s.membership.data.isActivePlus,
    isOnboarding: s => s.meta.isOnboarding,
    accessibleVenueIds: s => (s.membership.data.accessibleVenues || []).map(av => av.id)
  },
  mutations: {
    updateOnboarding: (s, value) => Vue.set(s.meta, 'isOnboarding', value)
  },
  modules: {
    account: {
      namespaced: true,
      ...accountStore
    },
    accountVerificationEmailsStore: {
      namespaced: true,
      ...accountVerificationEmailsStore
    },
    communicationPreferences: {
      namespaced: true,
      ...communicationPreferencesStore
    },
    profile: {
      namespaced: true,
      ...profileStore
    },
    membership: {
      namespaced: true,
      ...membershipStore
    },
    identity: {
      namespaced: true,
      ...identityStore
    },
    interests: {
      namespaced: true,
      ...interestsStore
    },
    occupations: {
      namespaced: true,
      ...occupationStore
    }
  }
}
